import React, { useState } from "react";
import "./App.css";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Menu from "./components/Menu";
import ChefsSpecial from "./components/ChefsSpecial";
import Gallery from "./components/Gallery";
import Reservations from "./components/Reservations";
import Contact from "./components/Contact";
import Testimonials from "./components/Testimonials";
import Footer from "./components/Footer";
import AdminPanel from "./components/AdminPanel";
import { Toaster } from "./components/ui/sonner";

function App() {
  const [isAdminOpen, setIsAdminOpen] = useState(false);

  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <About />
        <Menu />
        <ChefsSpecial />
        <Gallery />
        <Reservations />
        <Testimonials />
        <Contact />
      </main>
      <Footer onAdminClick={() => setIsAdminOpen(true)} />
      <Toaster />

      {/* Admin Panel */}
      <AdminPanel isOpen={isAdminOpen} onClose={() => setIsAdminOpen(false)} />
    </div>
  );
}

export default App;
